export const globalCss = {
  body: {
    // colorPalette: 'blue',
    fontFamily: "'Roboto', sans-serif",
  },
  html: {
    fontFamily: "'Roboto', sans-serif",
  },
};
